import { fg } from '@atlaskit/platform-feature-flags';

import { dashboardExperienceResource } from './DashboardExperienceResource';
import { staticConfigResource } from './StaticConfigResource';
import { resourceWithCondition } from './util';

export const dashboardResources = [
	dashboardExperienceResource,
	resourceWithCondition(() => !fg('platform_avp_static-app-props'), staticConfigResource),
];
